(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Box", [], factory);
	else if(typeof exports === 'object')
		exports["Box"] = factory();
	else
		root["Box"] = factory();
})(this, function() {
return 